module.exports = __webpack_public_path__ + "static/media/bw.5eb3b648.svg";